import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import moment from "moment";

import { Web3StatusContext } from "../../contexts/Web3StatusContext";

const { AccountData, ContractData, ContractForm } = newContextComponents;

class SetTime extends React.Component {
  static contextType = Web3StatusContext;
  state = { dataKey: null, unixtime: 0 };

  componentDidMount() {
    const { drizzle } = this.props;
    const contract = drizzle.contracts.GAMEFORESTSale;
  
    // let drizzle know we want to watch the `myString` method
    const dataKey = contract.methods[this.props.dateName].cacheCall(this.props.getterParameter);
  
    // save the `dataKey` to local component state for later reference
    this.setState({ dataKey });
  }
  
  myChangeHandler = (event) => {
    let { value } = event.target;
    
    var inputState = value;
    this.setState({unixtime: inputState});
  }

  mySubmitHandler = (event) => {
    event.preventDefault();
    if(this.context.activeAccount == null) {
      console.log('no active account to approve');
      return;
    }
    const { drizzle } = this.props;
    const { GAMEFORESTSale } = drizzle.contracts;

    var stackId;
    
    stackId = GAMEFORESTSale.methods[this.props.setterName].
                  cacheSend(this.props.setterParameter, this.state.unixtime);
    this.setState({ stackId: stackId });
  }

  // destructure drizzle and drizzleState from props
  render() {
    // get the contract state from drizzleState
    const { GAMEFORESTSale } = this.props.drizzleState.contracts;

    // using the saved `dataKey`, get the variable we're interested in
    const unixdate = GAMEFORESTSale[this.props.dateName][this.state.dataKey];
    
    if(unixdate !== undefined) {
      var dateString = moment.unix(unixdate.value).format("DD MMM YYYY HH:mm ZZ");
      return (
      <div>
        <div>{unixdate.value}</div>
        <div>{dateString}</div>
        <form onSubmit={this.mySubmitHandler}>
            unix time
            <br/>
            <input
                type="number"
                value={this.state.unixtime}
                onChange={this.myChangeHandler}
              />
              <br/>
            <input
            type='submit'
            value="Set State"
            />
          </form>
      </div>);
    }
    return <div>Loading...</div>;
  }
};

export default SetTime;